import i from "styled-components";
import { Base as o } from "./atoms-v2777.js";
import { INPUT_PRODUCTIVE_X_PADDING as e, INPUT_EXPRESSIVE_X_PADDING as p } from "./atoms-v2810.js";
const s = i.div`
  ${o}
  /* This custom property isn’t used in this component, but some of the child components rely on it. */
  --padding-x: ${({ $variant: t }) => t === "productive" ? e : p}px;

  ${o}

  display: flex;
  flex-direction: column;
  row-gap: 4.5px;
`;
export {
  s as InputContainer
};
